var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#FF9FD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2419 24.11L24.9219 22.43C25.1481 22.2066 25.4344 22.0536 25.746 21.9897C26.0575 21.9258 26.3809 21.9537 26.6769 22.07L28.7244 22.8875C29.0235 23.0089 29.2799 23.2162 29.4615 23.4831C29.643 23.75 29.7414 24.0647 29.7444 24.3875V28.1375C29.7426 28.3571 29.6965 28.5741 29.6087 28.7753C29.5209 28.9766 29.3932 29.158 29.2335 29.3087C29.0737 29.4594 28.8851 29.5761 28.679 29.652C28.473 29.7278 28.2537 29.7612 28.0344 29.75C13.6869 28.8575 10.7919 16.7075 10.2444 12.0575C10.2189 11.8292 10.2422 11.598 10.3125 11.3793C10.3828 11.1606 10.4987 10.9592 10.6524 10.7885C10.8062 10.6177 10.9943 10.4815 11.2045 10.3887C11.4147 10.2959 11.6421 10.2486 11.8719 10.25H15.4944C15.8176 10.251 16.1332 10.3486 16.4005 10.5304C16.6678 10.7122 16.8746 10.9698 16.9944 11.27L17.8119 13.3175C17.9321 13.6123 17.9627 13.936 17.9 14.2481C17.8373 14.5603 17.6841 14.847 17.4594 15.0725L15.7794 16.7525C15.7794 16.7525 16.7469 23.3 23.2419 24.11Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c26186a1837a0fcc4b6df71abd3e2cd0.svg";
export { ForwardRef as ReactComponent };